export default __webpack_public_path__ + "static/3-fe24d6a4fd6695356b66d4be92d852cc.jpeg";